export interface IncidentReportForm {
  serviceProvider: string
  program: string
  location: string
  date: string
  time: string
  clientName: string
  clientDob: string
  isCritical: boolean
  isNonCritical: boolean
  details: string
  actionTaken: string
  employeeName: string
  employeePosition: string
  employeeSignature: string
  employeeDate: string
  managerName: string
  managerPosition: string
  managerSignature: string
  managerDate: string
}

export const INCIDENT_REPORT_FORM_DEFAULTS: IncidentReportForm = {
  serviceProvider: '',
  program: '',
  location: '',
  date: '',
  time: '',
  clientName: '',
  clientDob: '',
  isCritical: false,
  isNonCritical: false,
  details: '',
  actionTaken: '',
  employeeName: '',
  employeePosition: '',
  employeeSignature: '',
  employeeDate: '',
  managerName: '',
  managerPosition: '',
  managerSignature: '',
  managerDate: ''
}
